export default __webpack_public_path__ + "static/media/HyperComplex Seminar in Fundamental Modelling.6db0cdfe.jpg";